import React from 'react';
import PropTypes from 'prop-types';
import Loader from '@Components/Loader';
import { BATCH_SEARCH_PROGRESS_MODAL_STATUS } from '../BatchSearchProgressModalConstants';

function BatchSearchProgressModalContent(props) {
  const { status, progressPercentage, queryRunning, queriesTotal, singleDatabase, currentDbName } = props;

  return (
    <div className="batch-search-modal__content">
      {status === BATCH_SEARCH_PROGRESS_MODAL_STATUS.RUNNING && (
        <Loader className="batch-search-modal__content_loader" progressValue={progressPercentage} />
      )}
      {status === BATCH_SEARCH_PROGRESS_MODAL_STATUS.RUNNING && (
        <div className="batch-search-modal__content_text u-els-font-size-h5">
          <div>{`Query ${queryRunning} of ${queriesTotal} in progress.`}</div>
          <div>{`Now searching in ${singleDatabase ? currentDbName : 'all databases'}`}</div>
        </div>
      )}
      {status === BATCH_SEARCH_PROGRESS_MODAL_STATUS.COMBINING && (
        <div className="batch-search-modal__content_text u-els-font-size-h5">Combining results...</div>
      )}
    </div>
  );
}

BatchSearchProgressModalContent.propTypes = {
  status: PropTypes.string,
  queryRunning: PropTypes.number,
  queriesTotal: PropTypes.number,
  singleDatabase: PropTypes.bool,
  progressPercentage: PropTypes.number,
  currentDbName: PropTypes.string,
};

export default BatchSearchProgressModalContent;
